async function scroller(id, setTargetIDToScrollTo = false, offset = -150) {
  if (setTargetIDToScrollTo) {
    setTargetIDToScrollTo(id);
  }

  const element = document.getElementById(id);

  if (element) {
    const y =
      element.getBoundingClientRect().top + document.body.scrollTop + offset;

    setTimeout(() => {
      // document.body.scrollTo({
      //   top: y,
      //   behavior: "smooth",
      // });
      // window.scrollTo({
      //   top: y,
      //   behavior: "smooth", // optional, adds smooth scrolling animation
      // });

      // const element = document.getElementById('targetElement');
      element.scrollIntoView({
        behavior: "smooth", // Optional: add smooth scrolling animation
        block: "center", // Align the top of the element with the top of the viewport
        // inline: "nearest", // Align the element horizontally with the nearest edge of the viewport
        // offsetTop: 500, // Vertical offset in pixels
      }); // smooth scroll
      setTimeout(() => {
        document.getElementById(id).focus();
      }, 2000);
    }, 100);
  }
}

export default scroller;
